import axios from 'axios';
export default {
	init() {
		return axios.get('/apps/prize-competition/api/init');
	},
	submitForm(model) {
		return axios.post('/apps/prize-competition/api/narrowed-form', model);
	},
	lookupBirthPlaces(query) {
		return axios.get(`/apps/prize-competition/api/settlement?name=${encodeURIComponent(query)}`);
	}
};
